import { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Container, Card } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Header } from 'components';
import ExperienceThemeForm from '../../../components/Forms/ExperienceThemeForm';
import { getTheme, updateTheme } from 'api/node/themes';
import { useAsync } from 'react-async';
import { isEqual } from 'lodash';

const EditTheme = () => {
  const { themeId } = useParams();
  const { state: selectedLocale } = useLocation();
  const { t } = useTranslation('experienceTheme');
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const [currentLocale, setCurrentLocale] = useState(selectedLocale);

  const { data } = useAsync({
    promiseFn: getTheme,
    themeId,
    locale: currentLocale?.value,
    watchFn: (props, prevProps) => {
      return !isEqual(props.locale, prevProps.locale);
    },
  });

  const handleUpdateTheme = async (values) => {
    try {
      await updateTheme({
        locale: currentLocale?.value,
        themeId,
        payload: values,
      });

      navigate('/settings/experiences/themes', { state: currentLocale });
      notify(t('editThemeSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <Header />

      <Container size="narrow">
        <Card>
          <ExperienceThemeForm
            onSubmit={handleUpdateTheme}
            theme={data?.data}
            queryLocale={currentLocale}
            updateQueryLocale={setCurrentLocale}
          />
        </Card>
      </Container>
    </>
  );
};

export default EditTheme;
